<template>
  <el-select
    v-model="input"
    multiple
    placeholder="Select a Carrier"
    clearable
    class="w-100"
    @change="handleSelect"
  >
    <el-option
      v-for="item in carrierSettings"
      :key="item.carrier.id"
      :label="item.carrier.full_name"
      :value="item.carrier.id"
    />
  </el-select>
</template>

<script>
export default {
  props: {

    disabled: {
      type: Boolean,
      required: false,
      default () {
        return false
      }
    },
    carrierSettings: {
      type: Array,
      required: false,
      default () {
        return ''
      }
    }

  },
  data () {
    return {
      input: ''
    }
  },

  methods: {
    handleSelect (item) {
      this.input = item
      this.$emit('input', item)
    },
    clearInput () {
      this.input = ''
      this.$emit('input', '')
    },
    getCarrierId () {
      return this.input
    }
  }
}
</script>

<style>

</style>
